import React, { useState } from "react";

const FAQHomePage = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleIndex = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "What types of sports turfs does ZajraGreen install?",
      answer:
        "We specialize in football turfs, box cricket turfs, multi-sport courts, school playground turf, and customizable recreational turf surfaces.",
    },
    {
      question: "How long does a turf installation take?",
      answer:
        "Depending on size and design, installation typically takes 3 to 10 days, including base preparation, leveling, drainage work, turf laying, and grooming.",
    },
    {
      question: "Do you provide maintenance services?",
      answer:
        "Yes! We offer complete maintenance services including brushing, infill top-up, deep cleaning, drainage check, and turf life extension treatments.",
    },
    {
      question: "What is the lifespan of a sports turf?",
      answer:
        "With proper maintenance, ZajraGreen sports turfs last between 6 to 10 years, depending on usage intensity and climate conditions.",
    },
    {
      question: "Do you use FIFA-approved or certified turf materials?",
      answer:
        "Yes. We provide high-quality, FIFA-certified and lab-tested materials to ensure durability, performance, and athlete safety.",
    },
    {
      question: "Can ZajraGreen build custom-sized turfs?",
      answer:
        "Absolutely. We construct turf projects of any size — from small 5-a-side grounds to full-size football fields and indoor arenas.",
    },
    {
      question: "Do you offer drainage and leveling work?",
      answer:
        "Yes. Our installation includes soil leveling, base compaction, slope creation, and a multi-layer drainage system for long-lasting turf performance.",
    },
    {
      question: "What is the cost of turf installation?",
      answer:
        "The cost varies based on area size, turf type, base preparation, and custom requirements. Contact us for a free site assessment and quote.",
    },
    {
      question: "Do you provide warranty?",
      answer:
        "Yes. All ZajraGreen turf products come with manufacturer warranty and installation guarantee to ensure long-term support.",
    },
  ];

  return (
    <div className="bg-gray-50 py-16">
      <div className="max-w-5xl mx-auto px-6">

        <h2 className="text-3xl md:text-4xl font-extrabold bg-gradient-to-r from-green-600 via-emerald-500 to-lime-400 bg-clip-text text-transparent text-center mb-10">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white border rounded-xl shadow-sm hover:shadow-lg transition duration-300"
            >
              <button
                className="w-full text-left px-6 py-4 font-medium text-lg flex justify-between items-center focus:outline-none rounded-t-xl bg-gray-100"
                onClick={() => toggleIndex(index)}
              >
                {faq.question}
                <span className="text-gray-500 text-2xl">
                  {activeIndex === index ? "−" : "+"}
                </span>
              </button>

              <div
                className={`overflow-hidden transition-all duration-500 ${
                  activeIndex === index ? "max-h-96 p-6 text-gray-700" : "max-h-0"
                }`}
              >
                {activeIndex === index && <p>{faq.answer}</p>}
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default FAQHomePage;
